module.exports = __webpack_public_path__ + "img/app_img3.08dad815.svg";